export const REQUEST_EMAIL = 'email';
export const REQUEST_MOBILE = 'mobile';
export const NO_REQUEST = 'ok';

export const REQUEST_SCREEN = 'REQUEST_SCREEN';
export const SUCCESS_SCREEN = 'SUCCESS_SCREEN';
export const CONFLICT_SCREEN = 'CONFLICT_SCREEN';
